module.exports = __webpack_public_path__ + "assets/Retina-MediumItalic.757e4aa42d3fbae68c9d284ea208fe96.woff";